import { Component, EventEmitter, OnChanges } from '@angular/core';
import { Console } from 'console';
import { AuthService } from '../../auth/services/auth.service';
import { BaseComponent } from '../../shared/base-components/base.component';
import { ModalSize } from '../../shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerIdentification } from '../models/customer-identification.model';
import { CustomerIdentificationType, ICustomerIdentificationType } from '../models/enums/customer-identification-type.enum';
import { CustomerManageService } from '../shared/customer-manage.service';
import { EinPipe } from '../shared/pipes/ein.pipe';
import { SsnPipe } from '../shared/pipes/ssn.pipe';
import { CustomerIdentificationModalComponent, IdentificationContext } from './customer-identification-modal.component';
import { HistoricalCustomerIdentificationModalComponent, HistoricalIdentificationContext } from './historical-customer-identification-modal.component';

@Component({
    selector: 'customer-identification',
    templateUrl: './customer-identification.html',
    inputs: ['customerNumber', 'identifications', 'canEdit', 'canEditLegacyCustomerNumber', 'componentTitle'],
    outputs: ['ssnChanged', 'identificationsChanged']
})
export class CustomerIdentificationComponent extends BaseComponent implements OnChanges {
    public identifications: CustomerIdentification[];
    public customerNumber: number;
    public canEdit: boolean;
    public canEditLegacyCustomerNumber: boolean;
    public componentTitle = 'Identifications';

    public ssnChanged = new EventEmitter<boolean>();
    public identificationsChanged = new EventEmitter();
    private identificationTypes = new CustomerIdentificationType();

    constructor(
        public modalService: MvdModalService,
        private customerService: CustomerManageService,
        private _einPipe: EinPipe,
        private _ssnPipe: SsnPipe,
        private _authService: AuthService
    ) {
        super();
    }

    public ngOnInit() {
        if (this.identifications !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumber != null) {
            this.populateIdentifications(this.customerNumber);
        }
    }

    public ngOnChanges() {
        if (this.identifications !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumber != null) {
            this.populateIdentifications(this.customerNumber);
        }
    }

    public populateIdentifications = (customerNumberId: number): void => {
        this.customerService.getCustomerIdentifications(customerNumberId).subscribe(result => {
            this.identifications = result;
        }, e => {
            console.log('error', e);
        }, () => {
            this.denormalizeData();
        });
    };

    public denormalizeData = (): void => {
        for (const identification of this.identifications) {
            let identType = this.getValues(identification.customerIdentificationTypeId, this.identificationTypes);
            identification.identificationType = identType.displayValue;
            identification.allowEdit = identType.isEditable;
        }
    };

    public getValues = (id: number, types: CustomerIdentificationType): ICustomerIdentificationType => {
        if (id !== undefined && id !== null) {
            return types.FromId(id);
        } else {
            return null;
        }
    };

    public editIdentification(id: number = 0) {
        const data = new IdentificationContext(id, this.customerNumber, this.identifications.some(ident => ident.customerIdentificationTypeId === this.identificationTypes.OtherIdentificationNumber.id));
        this.modalService.open(CustomerIdentificationModalComponent, data, ModalSize.Medium).afterClosed()
            .subscribe(
                result => {
                    this.identificationsChanged.emit();
                    this.populateIdentifications(this.customerNumber);

                    if (result != undefined && result.ssnChanged) {
                        this.ssnChanged.emit(result.ssnChanged);
                    }
                }
            );
    }

    /**
     * Shows the identification history
     * @param id
     */
    public showHistory = (id: number): void => {
        const data = new HistoricalIdentificationContext(id, this.customerNumber);
        this.modalService.open(HistoricalCustomerIdentificationModalComponent, data);
    };

    public formatIdentificationValue = (value: CustomerIdentification): string => {
        if (this.identificationTypes.EIN.id == value.customerIdentificationTypeId) {
            return this._einPipe.transform(value.customerIdentificationValue);
        } else if (this.identificationTypes.SSN.id == value.customerIdentificationTypeId) {
            return this._ssnPipe.transform(value.customerIdentificationValue);
        }

        return value.customerIdentificationValue;
    };

    public hasAccessControlClaim = (): boolean => this._authService.hasACSTransactionClaimEx(this._authService.acsTransactionClaim, 'UpdCustIdentification');

    public canEditIdentType(identTypeId: number): boolean {
        return identTypeId !== this.identificationTypes.ELT.id || this._authService.hasACSTransactionClaimEx(this._authService.acsTransactionClaim, 'SetELTIdentType');
    }

    public canEditIdentificationType(identTypeId: number): boolean {

        if (identTypeId == this.identificationTypes.ArizonaIDNumber.id || identTypeId == this.identificationTypes.ArizonaDriverLicense.id || identTypeId == this.identificationTypes.LegacySequenceNumber.id || identTypeId == this.identificationTypes.LegacyCustomerNumber.id) {
            if (identTypeId == this.identificationTypes.LegacyCustomerNumber.id && this.canEditLegacyCustomerNumber) {
                return true;
            }
            return false;
        }

        return true;
    }
}
